import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React, { Fragment } from "react";
var FILTER_PROPS = {
    height: "40px",
    borderRadius: "20px"
};
export var SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: getSpacing(120),
                height: getSpacing(20)
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "2x"
            }),
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: getSpacing(160),
                height: getSpacing("5x")
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: "50%",
                height: getSpacing(20)
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "2x",
                    desktopAndAbove: "4x"
                }
            }),
            /*#__PURE__*/ _jsxs(Row, {
                style: {
                    overflowX: "hidden"
                },
                children: [
                    /*#__PURE__*/ _jsx(LoadingSkeleton, _object_spread({
                        width: "44px"
                    }, FILTER_PROPS)),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, _object_spread({
                        width: "44px"
                    }, FILTER_PROPS)),
                    /*#__PURE__*/ _jsxs(Row, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "2x"
                            }),
                            /*#__PURE__*/ _jsx(LoadingSkeleton, _object_spread_props(_object_spread({}, FILTER_PROPS), {
                                width: "120px"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                        tabletAndAbove: /*#__PURE__*/ _jsxs(Fragment, {
                            children: [
                                /*#__PURE__*/ _jsxs(Row, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            width: "2x"
                                        }),
                                        /*#__PURE__*/ _jsx(LoadingSkeleton, _object_spread_props(_object_spread({}, FILTER_PROPS), {
                                            width: "120px"
                                        }))
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Row, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            width: "2x"
                                        }),
                                        /*#__PURE__*/ _jsx(LoadingSkeleton, _object_spread_props(_object_spread({}, FILTER_PROPS), {
                                            width: "120px"
                                        }))
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                        desktopAndAbove: /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Spacer, {
                                    width: "2x"
                                }),
                                /*#__PURE__*/ _jsx(LoadingSkeleton, _object_spread_props(_object_spread({}, FILTER_PROPS), {
                                    width: "120px"
                                }))
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            })
        ]
    });
};
